import { render, staticRenderFns } from "./KifuCategory.vue?vue&type=template&id=176096b2&scoped=true&"
import script from "./KifuCategory.vue?vue&type=script&lang=js&"
export * from "./KifuCategory.vue?vue&type=script&lang=js&"
import style0 from "./KifuCategory.vue?vue&type=style&index=0&id=176096b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176096b2",
  null
  
)

export default component.exports